import React, { memo, useEffect, useState } from 'react';
import './css/style.scss';
import { toast } from 'react-toastify';
import '../../../../components/centerModal/css/centerModal.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay, Lazy } from 'swiper';
import CountDown from './components/TimeLeft';
import dayjs from 'dayjs';
import ShareCard from '../../../ShareCard';
import { useDispatch } from 'react-redux';
import { requestRecording } from '../../../../Store/actions/session.action';
import ReactHtmlParser from 'react-html-parser';
import { reactHtmlParser } from '../../../../common/common';
import { Modal, Form, FloatingLabel } from 'react-bootstrap';
import { getLocalStorage, log, timeDifference } from '../../../../common/common';
import { changeSettings, otpVerifyForChange } from '../../../../Store/actions/profile.action';
import { AchievementColor, IoIosArrowDown } from '../../../icons';
import LazyImage from '../../../CustomLibraries/LazyImage';
import useRedirect from '../../../customHooks/useRedirect';
import { getUserDetails } from '../../../../Store/actions';
import DoctorsSectionForCard from '../../../DoctorSectionForCard/DoctorsSectionForCard';
import CpdPoint from './components/CpdPoint';
import InView from 'react-intersection-observer';
import { useTrackUserActivity } from '../../../customHooks/useTrackUserActivity';
import isdCodeJson from '../../../../common/data/isdcode.json';
// install Swiper modules
SwiperCore.use([EffectFade, Autoplay]);
// let userDetails;

const SessionCardV1 = ({
  data = '',
  startSessionCountDown = false,
  hideImage = false,
  click,
  onGetRecClick,
  gtmTagVariable = ''
}) => {
  // console.log(data, click, onGetRecClick);
  const dispatch = useDispatch();
  const { redirectTo } = useRedirect();
  let sponsorLogoSeperated = data?.sponsor_logo ? data?.sponsor_logo.split(',') : [];
  let sponsorLogo = data?.sponsor_entity ? data?.sponsor_entity : [];

  let isLiveStart =
    data && data?.start_datetime && data?.end_datetime
      ? timeDifference(data?.start_datetime) >= 0 && timeDifference(data?.end_datetime) <= 0
      : false;
  // console.log('TIME DIFF START', timeDifference(data?.start_datetime));
  // console.log('TIME DIFF START', timeDifference(data?.end_datetime));
  const diff = dayjs(data?.start_datetime).diff(dayjs(new Date()));
  const [show, setShow] = useState(false);
  const [recordingType, setRecordingType] = useState(2);
  const [modalSlide, setModalSlide] = useState(1);

  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [isd, setIsd] = useState('+91');
  const [isHoverd, setIsHoverd] = useState(false);
  const [isbtnHoverd, setIsbtnHoverd] = useState(false);

  const [activeHover, setActiveHover] = useState(false);

  const { userActivityTracker } = useTrackUserActivity();

  const cardClick = () =>
    click ? click() : redirectTo('SessionDetails', data.session_id, data.session_topic);
  const shareClick = () => {};
  // const onGetRecClick = () => {};
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setModalSlide(1);
  };
  const userDetails = () => (getLocalStorage('user', false) ? getLocalStorage('user', {}) : {});

  const addDefaultSrc = (ev) => {
    ev.target.src =
      'https://previews.123rf.com/images/varijanta/varijanta1604/varijanta160400086/55848266-modern-thin-line-design-concept-for-healthcare-website-banner-vector-illustration-concept-for-health.jpg';
  };
  const requestGetRecording = () => {
    dispatch(
      requestRecording(data.session_id, recordingType, (res) => {
        if (res != 'error') {
          if (res.status_code == 200) {
            toast.success(
              'We have received your request. We will send you the recording when the session is completed'
            );
          } else if (res.status_code == 203) {
            toast.error('You have already requested. Please wait till the session is completed');
          }
          handleClose();
        }
      })
    );
  };
  const getRecording = () => {
    if (userDetails()?.mobile_primary && userDetails()?.email) {
      requestGetRecording();
    } else {
      setModalSlide(2);
    }
  };
  const userVerification = () => {
    if (isd && mobile) {
      let regexMob = /^\d{10}$/;
      if (!mobile.match(regexMob)) {
        toast.error('Please Enter Mobile No in Correct Format');
      } else {
        let formdata = new FormData();
        formdata.append('type', 'mobile'); //'mobile', 'name', 'email', 'device'
        formdata.append('value', mobile); //for device value will be ""
        formdata.append('isd', isd);
        dispatch(
          changeSettings(formdata, (res) => {
            if (res != 'error') {
              if (res.status_code == 200) {
                log('response', res);
                setModalSlide(3);
              } else if (res.status_code == 203) {
                toast.error(res?.message);
              }
            }
          })
        );
      }
    } else if (email) {
      let regexEmail =
        /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
      if (!email.match(regexEmail)) {
        toast.error('Please Enter a Valid Email');
      } else {
        let formdata = new FormData();
        formdata.append('type', 'email'); //'mobile', 'name', 'email', 'device'
        formdata.append('value', email); //for device value will be ""
        dispatch(
          changeSettings(formdata, (res) => {
            if (res != 'error') {
              if (res.status_code == 200) {
                log('response', res);
                setModalSlide(3);
              } else if (res.status_code == 203) {
                toast.error(res?.message);
              }
            }
          })
        );
      }
    } else {
      toast.error('Please fill the mandatory field');
    }
  };
  const otpVerification = () => {
    console.log('in verify');
    if (isd && mobile) {
      let formdata = new FormData();
      formdata.append('type', 'verify');
      formdata.append('mobile_no', mobile);
      formdata.append('isd', isd);
      formdata.append('otp', otp);
      dispatch(
        otpVerifyForChange(formdata, (res) => {
          if (res != 'error') {
            if (res.status_code == 200) {
              log('response', res);
              requestGetRecording();
              dispatch(getUserDetails((res) => {}));
            } else if (res.status_code == 203) {
              toast.error(res?.message);
            }
          }
        })
      );
    } else if (email) {
      let formdata = new FormData();
      formdata.append('type', 'emailverify');
      formdata.append('email', email);
      formdata.append('otp', otp);
      dispatch(
        otpVerifyForChange(formdata, (res) => {
          if (res != 'error') {
            if (res.status_code == 200) {
              log('response', res);
              requestGetRecording();
            } else if (res.status_code == 203) {
              toast.error(res?.message);
            }
          }
        })
      );
    }
  };

  return (
    <>
      <InView
        threshold={1}
        as="div"
        onChange={(inView) => {
          userActivityTracker(inView, { ...data, type: 'session' }, 'card');
        }}
      >
        <div className="w-100 float-start ssnCardV1Box shadow rounded-3 overflow-hidden position-relative bg-white">
          <span
            className="graph-1 position-absolute start-0 bottom-0"
            style={{ backgroundColor: data?.color && data?.color != '0' ? data?.color : '#34caf5' }}
          ></span>
          <span
            className="graph-2 position-absolute start-0 bottom-0"
            style={{ backgroundColor: data?.color && data?.color != '0' ? data?.color : '#34caf5' }}
          ></span>
          {!hideImage && (
            <div
              className="w-100 float-start ssnCardV1BoxPic cursorPointer overflow-hidden position-relative d-flex justify-content-center align-items-center"
              onClick={cardClick}
            >
              <LazyImage
                src={data?.cover_image}
                fallback_image={
                  'https://previews.123rf.com/images/varijanta/varijanta1604/varijanta160400086/55848266-modern-thin-line-design-concept-for-healthcare-website-banner-vector-illustration-concept-for-health.jpg'
                }
                alt="banner"
                className={`object-fit-cover w-100 h-100 float-start position-absolute top-0 start-0 gtm_cl_SessionCardV1`}
              />

              <div className="overlay d-flex align-items-center justify-content-center">
                {data?.session_status == 3 && (
                  <div className="text-center">
                    <div className="row">
                      <div className="col">
                        <h4 className="fw-semibold fs-4 text-white">
                          <span className="fw-bold fs-2 d-block">Session Closed</span>
                        </h4>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <CpdPoint data={data} />
              <div className="d-flex align-items-center justify-content-between fw-semibold text-white fs-16 ssnCardV1Date position-absolute bottom-0 start-0 w-100 py-1 px-3 py-lg-2 px-lg-4">
                <div
                  className="ssnCardV1DateBg position-absolute top-0 start-0 w-100 h-100 bg-opacity-75"
                  style={{
                    backgroundColor: data?.color && data?.color != '0' ? data?.color : '#34caf5'
                  }}
                ></div>
                {data?.session_status == 4 ? (
                  <span className="position-relative z-1">Upcoming TBA</span>
                ) : (
                  <span className="position-relative z-1">
                    {dayjs(data?.start_datetime).format('ddd, D MMM')}
                  </span>
                )}
                {data?.session_status != 4 && (
                  <span className="position-relative z-1">
                    {dayjs(data?.start_datetime).format('hh:mm A')}
                  </span>
                )}
              </div>
              <div className="d-flex align-items-center justify-content-between cardTimeLogo position-absolute top-0 start-0 p-3 p-lg-4 w-100">
                {startSessionCountDown &&
                data?.start_datetime &&
                data?.session_status != 4 &&
                data?.session_status != 3 &&
                data?.session_status != 6 &&
                !isLiveStart &&
                diff > 0 ? (
                  <CountDown date={data?.start_datetime} />
                ) : (
                  <div></div>
                )}
                {/* sponser logo if single ==========*/}
                {sponsorLogoSeperated?.length > 0 ? (
                  <Swiper
                    className="crdV1sponser rounded m-0 text-center py-2 px-3 bg-white z-4"
                    navigation={false}
                    spaceBetween={0}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{
                      delay: 2500
                    }}
                    effect={'fade'}
                  >
                    {sponsorLogoSeperated.map((logo, _i) => (
                      <SwiperSlide
                        className="crdV1sponserIn bg-white position-relative w-100"
                        key={_i + 1}
                      >
                        <LazyImage
                          src={logo}
                          className="position-absolute top-50 start-50 translate-middle mw-100 mh-100 w-auto h-auto"
                          alt="sponsor"
                          logo
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <>
                    {sponsorLogo?.length == 1 && (
                      <div className="crdV1sponser rounded m-0 text-center py-2 px-3 bg-white z-4">
                        <div className="crdV1sponserIn bg-white position-relative w-100">
                          <LazyImage
                            src={sponsorLogo[0].sponsor_logo}
                            className="position-absolute top-50 start-50 translate-middle mw-100 mh-100 w-auto h-auto"
                            alt="sponsor logo"
                            logo
                          />
                        </div>
                      </div>
                    )}
                    {/* sponser logo if single */}
                    {/* sponser logo if multiple */}
                    {sponsorLogo.length > 1 && (
                      <Swiper
                        className="crdV1sponser rounded m-0 text-center py-2 px-3 bg-white z-4"
                        navigation={false}
                        spaceBetween={0}
                        slidesPerView={1}
                        loop={true}
                        autoplay={{
                          delay: 2500
                        }}
                        effect={'fade'}
                      >
                        {sponsorLogo.map((logo, _i) => (
                          <SwiperSlide
                            className="crdV1sponserIn bg-white position-relative w-100"
                            key={_i + 1}
                          >
                            <LazyImage
                              src={logo.sponsor_logo}
                              className="position-absolute top-50 start-50 translate-middle mw-100 mh-100 w-auto h-auto"
                              alt="sponsor"
                              logo
                            />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
          <div className="w-100 float-start ssnCrdV1Btm p-3  ps-0 ps-lg-0">
            <div className="crdV1topPart d-flex align-items-center justify-content-between position-relative ps-3 mb-2 ps-lg-4">
              <span
                className="crdV1topPartGraph position-absolute start-0 top-50 translate-middle-y"
                style={{
                  backgroundColor: data?.color && data?.color != '0' ? data?.color : '#34caf5'
                }}
              ></span>
              <span className="fs-4 text-black crdV1Speclty d-flex">
                <i className="flaticon-customer-service-headset text-primary fs-3 me-3"></i>
                {/* <svg strokeWidth="0" viewBox="0 0 512 512" className="text-secondary fs-3 me-3">
                <path d="M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"></path>
              </svg> */}
                {data?.ms_cat_name}
              </span>
              <div className="d-flex align-items-center gap-2">
                {isLiveStart && data.session_status != 3 && (
                  <span className="text-danger fs-16 fw-semibold me-3 d-flex align-items-center gap-1">
                    <div className="pulseCircle me-2"></div> Live
                  </span>
                )}
                <a href="javascript:void(0)" className="cardV1DotsMenu text-black">
                  {/* <svg
                className="text-black fs-2"
                strokeWidth="0"
                viewBox="0 0 1024 1024"
              >
                <path d="M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z"></path>
              </svg> */}
                  <ShareCard
                    gtmTagVariable={`gtm_cl_SessionCardV1_share`}
                    customClass={`fs-3 text-black ${gtmTagVariable}_SessionCardV1`}
                    shareClick={shareClick}
                    data={{ title: data?.session_topic, url: data?.deeplink }}
                  />
                </a>
              </div>
            </div>
            {data?.is_multiday_session == 1 && (
              <div className="w-100 d-flex text-start mb-3 mt-1 ps-3 ps-lg-4 ">
                <span className="border border-2 fw-medium me-3 rounded px-3 py-2">
                  {data?.total_days ?? 0} Day(s)
                </span>
                <span className="border border-2 fw-medium me-3 rounded px-3 py-2">
                  {data?.total_session ?? 0} Session(s)
                </span>

                <span className="border border-2 fw-medium rounded px-3 py-2">
                  {data?.total_doctors ?? 0} Speaker(s)
                </span>
              </div>
            )}
            <div className="w-100 float-start d-flex text-start cardV1Topic ps-3 ps-lg-4 mb-2">
              {/* withChanel */}

              {/* withChanel */}
              <div
                className="cardV1TopicContent cursorPointer position-relative w-100"
                onClick={cardClick}
              >
                <h2
                  className={`text-black fs-16 fw-medium line-clamp-3 gtm_cl_SessionCardV1 lh-base text-break`}
                  // id={`${gtmTagVariable}_SessionCardV1_topic_${data.session_id}`}
                >
                  {reactHtmlParser(data?.session_topic)}
                </h2>
              </div>
            </div>
            <DoctorsSectionForCard
              type={'session'}
              cardData={data}
              gtmTagVariable={`gtm_cl_SessionCardV1`}
            />
            <div className="w-100 float-start cardV1Ftr d-flex align-items-center justify-content-between ps-3 ps-lg-4 mt-2">
              <button
                className={`cardV1FtrBtn d-inline-block overflow-hidden py-3 px-4 fs-4 fw-medium rippleEffect rounded cursorPointer gtm_cl_SessionCardV1_getRecording`}
                style={{
                  border: `${
                    isHoverd && activeHover
                      ? '1px solid transparent'
                      : `1px solid ${data?.color && data?.color != '0' ? data?.color : '#355fd3'}`
                  }`,
                  color: `${
                    isHoverd && activeHover
                      ? '#fff'
                      : data?.color && data?.color != '0'
                      ? data?.color
                      : '#355fd3'
                  }`,
                  backgroundColor: `${
                    isHoverd && activeHover
                      ? data?.color && data?.color != '0'
                        ? data?.color
                        : '#355fd3'
                      : 'transparent'
                  }`
                }}
                // id={`${gtmTagVariable}_SessionCardV1_getRecording_${data.session_id}`}
                onClick={() => {
                  handleShow();
                  typeof onGetRecClick == 'function' && onGetRecClick();
                }}
                onMouseEnter={() => {
                  setIsHoverd(true);
                  setActiveHover(true);
                }}
                onMouseLeave={() => {
                  setIsHoverd(false);
                  setActiveHover(false);
                }}
              >
                {/* <div
                className="cardV1BtnHover position-absolute top-50 start-50 translate-middle gtm_cl_SessionCardV1_getRecording"
                style={{ backgroundColor: data?.color ?? '#355fd3' }}
              ></div>
              <div
                className="cardV1BtnBorder rounded position-absolute start-0 top-50 translate-middle-y gtm_cl_SessionCardV1_getRecording"
                style={{ borderColor: data?.color ?? '#355fd3' }}
              ></div> */}
                {/* <span
                className="gtm_cl_SessionCardV1_getRecording"
                style={{ color: data?.color ?? '#355fd3' }}
              > */}
                Get Recording
                {/* </span> */}
              </button>
              <button
                className={`cardV1FtrBtn d-inline-block overflow-hidden py-3 px-4 fs-4 fw-medium rippleEffect rounded cursorPointer gtm_cl_SessionCardV1_attend_ViewSession_Join_viewCase_Button`}
                // id={`${gtmTagVariable}_SessionCardV1_attendButton_section_${data.session_id}`}
                onClick={cardClick}
                onMouseEnter={() => {
                  setIsbtnHoverd(true);
                  setActiveHover(true);
                }}
                onMouseLeave={() => {
                  setIsbtnHoverd(false);
                  setActiveHover(false);
                }}
                style={{
                  border: `${
                    isbtnHoverd
                      ? '1px solid transparent'
                      : `1px solid ${data?.color && data?.color != '0' ? data?.color : '#34caf5'}`
                  }`,
                  backgroundColor: `${
                    isbtnHoverd
                      ? data?.color && data?.color != '0'
                        ? data?.color
                        : '#34caf5'
                      : 'transparent'
                  }`
                }}
              >
                {/* <div
                className="cardV1BtnHover position-absolute top-50 start-50 translate-middle gtm_cl_SessionCardV1_attendButton"
                style={{ backgroundColor: data?.color ?? '#34caf5' }}
              ></div>
              <div
                className="cardV1BtnBorder rounded position-absolute start-0 top-50 translate-middle-y gtm_cl_SessionCardV1_attendButton"
                style={{ borderColor: data?.color ?? '#34caf5' }}
              ></div> */}
                <span
                  style={{
                    color: `${
                      isbtnHoverd
                        ? '#fff'
                        : data?.color && data?.color != '0'
                        ? data?.color
                        : '#355fd3'
                    }`
                  }}
                  className={`gtm_cl_SessionCardV1_attendButton d-flex align-items-center fs-4`}
                >
                  {data?.session_status == 3
                    ? 'View Session'
                    : isLiveStart
                    ? 'Join Now'
                    : data?.participant_id
                    ? 'View Case'
                    : 'Attend'}
                  <i className="flaticon-next ms-2 gtm_cl_SessionCardV1_attendButton"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
        <Modal className="centerModal" size="md" centered show={show} onHide={handleClose}>
          {modalSlide == 1 && (
            <>
              <Modal.Header>
                <Modal.Title className="fs-4 text-black fw-semibold">
                  Please choose a way from below
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <div className="w-100 float-start centerModalFrm">
                    <div className="row">
                      <Form.Group className="mt-3" controlId="formBasicCheckbox">
                        {['Get Presentation', 'Get Recording', 'Get Both'].map((_r, _idx) => (
                          <Form.Check
                            key={_idx + 1}
                            type="radio"
                            className={`cmnCheckbox mb-3 ps-0 gtm_cl_SessionCardV1_getRecording_options position-relative`}
                            // id="gtm_cl_SessionCardV1_getRecording_options"
                            label={_r}
                            checked={recordingType == _idx + 1}
                            value={_idx + 1}
                            onChange={(e) => setRecordingType(e.target.value)}
                          />
                        ))}
                      </Form.Group>

                      <div className="floatingFrmRow d-flex flex-wrap centerModalBttns">
                        <button
                          className={`col fs-4 fs-4 btn btn-danger gtm_cl_SessionCardV1_getRecording_cancel`}
                          type="button"
                          onClick={handleClose}
                          aria-label="Cancel"
                        >
                          Cancel
                        </button>
                        <button
                          className={`col fs-4 btn btn-primary gtm_cl_SessionCardV1_getRecording_submit`}
                          type="button"
                          onClick={getRecording}
                          aria-label="Submit"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </Modal.Body>
            </>
          )}
          {modalSlide == 2 && (
            <>
              <Modal.Header>
                <Modal.Title className="fs-4 text-black fw-semibold">
                  Please Confirm Your Credentials
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <div className="w-100 float-start centerModalFrm">
                    {!('email' in userDetails()) && (
                      <FloatingLabel
                        className="floatingFrmRow mb-3"
                        controlId="floatingInput"
                        label="Enter Your Email *"
                      >
                        <Form.Control
                          className="fs-4 gtm_cl_SessionCardV1_enter_email"
                          // id="gtm_cl_SessionCardV1_enter_email"
                          type="text"
                          placeholder="Enter Your Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </FloatingLabel>
                    )}
                    {!('mobile_primary' in userDetails()) && (
                      <div className="cmnisdCodeParent  mb-3">
                        <div className="cmnisdCodeSelect">
                          <select
                            onChange={(e) => {
                              setIsd(e.target.value);
                            }}
                            defaultChecked="+91"
                          >
                            {isdCodeJson.map((item, index) => (
                              <option name={item.name} value={item.value}>
                                {item.value}
                              </option>
                            ))}
                          </select>
                          <IoIosArrowDown customClass={'fs-16'} />
                        </div>
                        <FloatingLabel
                          className="floatingFrmRow"
                          controlId="floatingInput"
                          label="Enter Your Mobile No. *"
                        >
                          <Form.Control
                            className={`fs-4 gtm_cl_SessionCardV1_credential_enter_mobile_no`}
                            type="text"
                            placeholder="Enter Your Mobile No."
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                          />
                        </FloatingLabel>
                      </div>
                    )}
                    <div className="floatingFrmRow d-flex flex-wrap centerModalBttns">
                      <button
                        className={`col fs-4 btn btn-danger gtm_cl_SessionCardV1_credential_cancel`}
                        type="button"
                        onClick={handleClose}
                        aria-label="Cancel"
                      >
                        Cancel
                      </button>
                      <button
                        className={`col fs-4 btn btn-primary gtm_cl_SessionCardV1_credential_submit`}
                        type="button"
                        onClick={userVerification}
                        aria-label="Submit"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </Form>
              </Modal.Body>
            </>
          )}
          {modalSlide == 3 && (
            <>
              <Modal.Header>
                <Modal.Title className="fs-4 text-black fw-semibold">
                  Please Confirm Your OTP
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <div className="w-100 float-start centerModalFrm">
                    <div className="row">
                      <FloatingLabel
                        className="floatingFrmRow mb-3"
                        controlId="floatingInput"
                        label="Enter Your OTP *"
                      >
                        <Form.Control
                          className={`fs-4 gtm_cl_SessionCardV1_enter_otp`}
                          type="text"
                          placeholder="Enter Your OTP"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                        />
                      </FloatingLabel>

                      <div className="floatingFrmRow d-flex flex-wrap centerModalBttns">
                        <button
                          className={`col fs-4 btn btn-danger gtm_cl_SessionCardV1_enter_otp_cancel`}
                          type="button"
                          onClick={handleClose}
                          aria-label="Cancel"
                        >
                          Cancel
                        </button>
                        <button
                          className={`col fs-4 btn btn-primary gtm_cl_SessionCardV1_enter_otp_submit`}
                          type="button"
                          onClick={otpVerification}
                          aria-label="Submit"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </Modal.Body>
            </>
          )}
          {errMsg && (
            <Modal.Footer>
              <div className="w-100 float-start alert alert-danger">{errMsg}</div>
            </Modal.Footer>
          )}
        </Modal>
      </InView>
    </>
  );
};
export default memo(SessionCardV1);
